const map = {
	"./big-five-diagram-nb.png": 4727,
	"./big-five-diagram.en.svg": 48970,
	"./big-five-diagram.xx.svg": 907,
	"./gma-example-01.png": 94803,
	"./hardiness-nb.png": 52129,
	"./no-departments.svg": 79499,
	"./report-illustration.svg": 43085,
	"./skill-model-nb.png": 18035,
	"./skill-model.en.png": 59977,
	"./skill-model.nb.png": 83660,
	"./undraw_collaboration.svg": 78553,
	"./undraw_completed_tasks.svg": 3274,
	"./undraw_dashboard.svg": 51970,
	"./undraw_drag.svg": 52976,
	"./undraw_football_cards.svg": 95005,
	"./undraw_hire.svg": 64684,
	"./undraw_hiring.svg": 54253,
	"./undraw_report.svg": 95476,
	"./undraw_resume_folder.svg": 42334,
	"./undraw_selecting_team.svg": 69586,
	"./undraw_shared_goals.svg": 80908
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5397;